import { MemoIconEnum } from '../../../generated/api.graphql';

export const MemoIcon = Object.freeze({
  DELIVERY: MemoIconEnum.Delivery,
  HOLIDAY: MemoIconEnum.Holiday,
  MAINTENANCE: MemoIconEnum.Maintenance,
  NOTE: MemoIconEnum.Note,
  OUT_OF_OFFICE: MemoIconEnum.OutOfOffice,
});
export type MemoIcon = (typeof MemoIcon)[keyof typeof MemoIcon];
